export default __webpack_public_path__ + "static/media/key.0becb189.svg";